export default {"src":"/_next/static/media/02_LuckySpin_EN.45e6cd7f.gif","height":175,"width":439};